import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { blobTypeStoreReadSettingsAdapts } from './blob-type-store-read-settings.adapter';
import { GoogleCloudStorageStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/google-cloud-storage-store-read-settings';
import { AmazonS3StoreReadSettingsAdapter } from './s3-store-read-settings.adapter';

export const adapts = {
    ...blobTypeStoreReadSettingsAdapts,
    deleteFilesAfterCompletion: '*',
    prefix: '*'
};

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleCloudStorageStoreReadSettings),
    asynchronous: true,
    adapts
})
export class GoogleCloudStorageStoreReadSettingsAdapter extends AmazonS3StoreReadSettingsAdapter {}
